<app-modal-base
  [title]="dialogTitle"
  [hasSubmit]="false"
  [cancelType]="'CLOSE'"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="main">
      <p class="desc">
        Avec EEMO vous pouvez transférer le dossier à votre client pour qu'il en
        devienne propriétaire sur notre plateforme et qu'il puisse continuer à
        le renseigner.
      </p>
      <p>&nbsp;</p>
      <p>
        Découvrer nos offres :
        <a href="https://www.eemo.fr/tarifs-agents/#coffrets" target="_blank"
          >Page tarifs agents</a
        >.
      </p>
      <p>&nbsp;</p>
      <p>
        Contactez-nous à l'adresse
        <a
          href="mailto:premium@eemo.fr?subject=Je souhaite des informations sur le transfert de dossier pour le bien {{
            data.prop?.eemoId
          }}"
          target="_blank"
          >premium&#64;eemo.fr</a
        >
        pour en savoir plus.
      </p>
    </div>
  </div>
</ng-template>
